<!-- HTML -->
<template>
  <div>
    <section class="hero is-light">
      <br />
      <h1 class="title is-1">CONTACTO</h1>
      <div>
        <div class="columns">
          <div class="column">
            <div class="card tall">
              <a href="tel:+525532701276">
                <div class="card-content">
                  <div>
                    <img src="../assets/iphone.png" alt="phone" class="icon" />
                    <br />+52 (55) 3270 1276
                    <br />
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div class="column">
            <div class="card">
              <a href="https://goo.gl/maps/WzKKg6ifH4F3jq5F7" target="_blank">
                <div class="card-content">
                  <div>
                    <img src="../assets/location.png" alt="loc" class="icon" />
                    <br />Cracovia 72.
                    <br />Ciudad de México, México
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div class="column">
            <div class="card tall">
              <a href="mailto:bernardo.altamirano@menuly.page">
                <div class="card-content">
                  <div>
                    <img src="../assets/mail.png" alt="correo" class="icon" />
                    <br />
                    {{email}}
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template> 

<!-- JS -->
<script>
export default {
  name: "contacto",
  data() {
    return {
      email: "bernardo.altamirano@menuly.page",
      web: "https://menu-ly.web.app/"
    };
  }
};
</script>

<!-- SCSS -->
<style scoped lang="scss">
.tall {
  height: 100%;
}
.columns {
  padding: 25px;
}
.column {
  text-align: center !important;
}
.icon {
  height: 80px !important;
  width: auto !important;
}
.wide-separator-line {
  height: 1px;
  background-color: #5c5b5b;
  margin: 5% 20px;
}

a {
  color: #2c3e50;
  :hover {
    color: #9ed96b !important;
  }
}
.padding-sides-5 {
  padding-left: 5%;
  padding-right: 5%;
}
</style>
